import GenericDialog from "../../../../components/ui/dialogs/generic-dialog/GenericDialog";
import PropTypes from "prop-types";
import {CircularProgress, Typography} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import * as actions from '../../../../store';
import ConfirmContent from "./confirm/ConfirmContent";
import ConfirmActions from "./confirm/ConfirmActions";
import MainActions from "./main/MainActions";
import MainContent from "./main/MainContent";
import {E2_01_D_03_9} from "../../../texts";
import ChangePlanBySimConfirmationStepper
    from "../../../../components/mobile/sub-menu-items/contratto-digitale/digital-contract-details/tabs/offerte/offerte-piano-opzione-table/details-dialog/modifica-piano-dialog/ChangePlanBySimConfirmationStepper";
import ChangePlanSuccessAction
    from "../../../../components/mobile/sub-menu-items/contratto-digitale/digital-contract-details/tabs/offerte/offerte-piano-opzione-table/details-dialog/modifica-piano-dialog/ChangePlanSuccessAction";


const ChangePlanBySimDialog = (props) => {
    const dispatch = useDispatch()

    const userClaims = useSelector(state => state.authReducer.userClaims)
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany)
    const digitalContractPlanOptions = useSelector(state => state.digitalContractReducer.planOptionsForSim)
    const contrattoDigitalePlanOptions = useSelector(state => state.contrattoDigitaleReducer.currentOffer)
    const reportProblem = useSelector(state => state.serviceRequestReducer.reportProblem)
    const [sim] = props.sims

    const [selectedPlan, setSelectedPlan] = useState("")
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [step, setStep] = useState(0)

    useEffect(() => {
        dispatch(actions.fetchPlanOptionsForSim(sim.iccId))
    }, [dispatch, sim.iccId])

    useEffect(() => {
        if (props.isFromDC && reportProblem.success) {
            setStep(oldStep => oldStep + 1)
        }
    }, [props.isFromDC, reportProblem.success])

    const handleDialogClose = () => {
        props.handleDialogClose()
    }

    const handleCloseInfoDialog = () => {
        handleDialogClose()
        setOpenConfirmModal(false)
    }

    const handleChangeSelectedPlan = (e) => {
        setSelectedPlan(e.target.value)
        if (e.target.value !== "") {
            dispatch(actions.fetchOfferForNewPlan(
                e.target.value,
                    digitalContractPlanOptions.currentOffer.commercialLabel
            ))
        }
    }

    const handleProceedClick = () => {
        setOpenConfirmModal(true)
    }

    const handleConfirmModalCancelButton = () => {
        setOpenConfirmModal(false)
    }

    // This function gets from the top offer items the one that has canone in the title, as per design
    const getConfirmDialogBox = () => {
        const selectedOfferTopItemList = digitalContractPlanOptions.selectedPlanOffer.data.offertaTopItemList
        const index = selectedOfferTopItemList.findIndex(topItem => topItem.title.toLowerCase().includes("canone"))
        if (index >= 0) return {
            header: selectedOfferTopItemList[index].title,
            content: selectedOfferTopItemList[index].content
        }
        return {
            header: "",
            content: ""
        }
    }

    const handleConfirmModalAcceptButton = () => {
        dispatch(actions.submitReportInSegnalazione(
            selectedCompany.integrationId,
            selectedCompany.livelloDiAssistenzaId,
            E2_01_D_03_9,
            userClaims.uid,
            "", "", "",
            "", "",
            props.sims,
            selectedPlan)
        )
        if (props.isFromDC) {
            return
        }
        handleDialogClose()
        setOpenConfirmModal(false)

    }

    const getSelectedPlanName = (planId) => {
        return digitalContractPlanOptions.items.find(plan => plan.value === planId).text
    }

    const getDialogTitle = () => {
        if (props.isFromDC) {
            return "Modifica del piano per le SIM selezionate"
        }

        if (openConfirmModal) {
            return `Richiedi modifica del piano ${getSelectedPlanName(selectedPlan)} per la SIM ${props.sims[0].msisdn}`
        }

        if (props.sims.length === 1) {
            return `Richiedi modifica del piano per la SIM ${props.sims[0].msisdn}`
        }

        return "Modifica del piano per le SIM selezionate"
    }

    const dialogContent = () => {
        if (!openConfirmModal)
            return <MainContent selectedPlan={selectedPlan}
                                currentOffer={props.isFromDC ? contrattoDigitalePlanOptions.data : digitalContractPlanOptions.currentOffer}
                                isFromDC={props.isFromDC}
                                handleChangeSelectedPlan={handleChangeSelectedPlan}
                                menuItems={digitalContractPlanOptions.items}
                                loading={digitalContractPlanOptions.loading}/>
        if (props.isFromDC)
            return (digitalContractPlanOptions.selectedPlanOffer.loading ?
                <CircularProgress className="mr-24" size={25}/> :
                <ChangePlanBySimConfirmationStepper step={step}
                                                    sims={props.sims}
                                                    plan={digitalContractPlanOptions.selectedPlanOffer.data.planName}
                                                    planCost={digitalContractPlanOptions.selectedPlanOffer.data.offertaTopItemList[0].content}
                />)

        return <ConfirmContent description={digitalContractPlanOptions.selectedPlanOffer.data.planDescription}
                               box={getConfirmDialogBox()}/>
    }

    const dialogActions = () => {
        if (!openConfirmModal)
            return <MainActions handleDialogClose={handleDialogClose}
                                handleProceedClick={handleProceedClick}
                                selectedPlan={selectedPlan}/>

        if (props.isFromDC && step !== 0)
            return <ChangePlanSuccessAction closeDialog={handleCloseInfoDialog}/>

        return <ConfirmActions loading={reportProblem.loading}
                               handleConfirmModalCancelButton={handleConfirmModalCancelButton}
                               handleConfirmModalAcceptButton={handleConfirmModalAcceptButton}/>
    }

    return (
        <GenericDialog open={props.open}
                       loading={props.isFromDC ?
                           contrattoDigitalePlanOptions.loading :
                           digitalContractPlanOptions.loading}
                       dialogWidth={"md"}
                       dialogContent={dialogContent()}
                       dialogActions={dialogActions()}
                       handleDialogClose={handleDialogClose}
                       handleDialogCloseButton={handleDialogClose}>
            <Typography variant={"h6"}>
                {getDialogTitle()}
            </Typography>
        </GenericDialog>
    )
}

ChangePlanBySimDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    sims: PropTypes.arrayOf(
        PropTypes.shape({
            iccId: PropTypes.string.isRequired,
            msisdn: PropTypes.string.isRequired
        }).isRequired).isRequired,
    isFromDC: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired
}

export default ChangePlanBySimDialog
